import { render, staticRenderFns } from "./CancelList.vue?vue&type=template&id=2d2d0c2f&"
import script from "./CancelList.vue?vue&type=script&lang=ts&"
export * from "./CancelList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports